import DataStore from "@/components/GridWidget/DataStore";
import {getParameter} from "@/components/WdiBus/Buttons/data";
import {WdiModalAppProps, wdiCore} from "@/components/WdiControls";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {FormSaDetail} from "@/services/sales/sa";
import {formatter, request, ResponseStatus} from "@/utils/request";
import {ProFormInstance} from "@ant-design/pro-form";
import {message, TableColumnsType,} from "antd";
import {useEffect, useRef, useState} from "react";
import {Enum} from "@/enums/system";


const ModifyAmountModalApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const columns: TableColumnsType<API.FormSaDetailVo> = [
    {
      title: '行号',
      width: 50,
      dataIndex: 'rowNumber',
    },
    {
      title: '四级使用部门',
      dataIndex: 'boName',
      ellipsis: true,
      width: 200,
      render: (_, record) => record.boName,
    },
    {
      title: '客户',
      dataIndex: 'soldToCode',
      ellipsis: true,
      width: 200,
      render: (_, record) => wdiCore.String.Join(record.soldToCode, record.soldToName),
    },
    {
      title: '门店',
      dataIndex: 'shop',
      ellipsis: true,
      width: 200,
      render: (_, record) => wdiCore.String.Join(record.shopCode, record.shopName),
    },
    {
      title: '产品别',
      dataIndex: 'productBuyNames',
      ellipsis: true,
      width: 240,
    },
    {
      title: '费用项',
      dataIndex: 'ecName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '核算类型',
      dataIndex: 'revenueTypeName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '原转化率',
      dataIndex: 'executionRateForecastOriginal',
      width: 100,
      ellipsis: true,
      render: (_, record) => wdiCore.Number.RateToString(record.executionRateForecastOriginal),
    },
    {
      title: '新转化率',
      dataIndex: 'executionRateForecast',
      width: 100,
      ellipsis: true,
      render: (value: any, record) => {
        const revenueType = Number(record.revenueType);
        if (revenueType != Enum.RevenueType.FIXED) {
          return (
            <WdiInputNumber
              value={value} min={0} max={100} style={{width: '100%'}} format='p'
              onChange={(value) => {
                const {...newRecord} = record;
                const executionRateForecast = Number(value);
                newRecord.executionRateForecast = executionRateForecast;
                if (record.revenueType == Enum.RevenueType.POS_REV || record.revenueType == Enum.RevenueType.POS_REV_FIXED) {
                  //进价价差*预估销量*预计执行率/（1+税率）
                  newRecord.amount = wdiCore.Number.ToNumber(Number(record.revenuePosForecast) * Number(record.roiForecast) * executionRateForecast, 2);
                } else {
                  //计算列：预计SAP销售额*折扣费率*预计执行率
                  newRecord.amount = wdiCore.Number.ToNumber(Number(record.unitExpense) * Number(record.quantityPosForecast) * executionRateForecast, 2);
                }
                setDataSource(DataStore.edit(dataSource, newRecord));
              }}/>
          );
        } else {
          return wdiCore.Number.RateToString(record.executionRateForecastOriginal);
        }
      }
    },
    {
      title: '原申请金额',
      dataIndex: 'amountOriginal',
      width: 100,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value),
    },
    {
      title: '已核销金额',
      dataIndex: 'amountPaidInVat',
      width: 100,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value),
    },
    {
      title: '新申请金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value: any, record) => {
        if (record.revenueType == Enum.RevenueType.FIXED) {
          return (
            <WdiInputNumber
              value={value} min={0} style={{width: '100%'}} digits={2}
              onChange={(value) => {
                const {...newRecord} = record;
                newRecord.amount = Number(value);
                setDataSource(DataStore.edit(dataSource, newRecord));
              }}/>
          );
        } else {
          return wdiCore.Number.AmountToString(value)
        }
      },
    }
  ]

  useEffect(() => {
    if (props.id) {
      setLoading(true);
      FormSaDetail.getFormSaDetailVosForModifyAmount(Number(props.id)).then((response) => {
        if (response && response.data) {
          const formSaDetails = response.data
            .filter(m => m.revenueType == Enum.RevenueType.FIXED || (Number(m.revenueType) >= 301 && Number(m.revenueType) < 400));
          for (let i = 0; i < formSaDetails.length; i++) {
            const formSaDetail = formSaDetails[i];
            formSaDetail.executionRateForecastOriginal = formSaDetail.executionRateForecast;
            formSaDetail.amountOriginal = formSaDetail.amount;
          }
          setDataSource(DataStore.init(formSaDetails));
          setLoading(false);
        }
      });
    }
  }, [props.id]);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      width={1350}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      onFinish={async () => {
        const {data} = props;
        const args = getParameter(data);
        args.items.push({name: "formSaDetails", value: JSON.stringify(dataSource)});
        const response = await request(data.url, formatter({method: 'POST', body: args}));
        if (response.code == ResponseStatus.SUCCESS) {
          message.success('操作成功');
          if (props.onSave) {
            props.onSave();
          }
        } else {
          message.error(response.message);
        }
      }}
    >
      <WdiTable
        height={507}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        aggrColumns={["amountOriginal", "amountPaidInVat", "amount"]}
        footerSummaryFixed={true}
        allowFilterColumn={true}
      />
    </WdiModalForm>
  );
};

export default ModifyAmountModalApp;
